import { BaseContentLayout } from '@components';
import { SURFACE_COLORS } from '@constants/colors.ts';
import { ABOVE_DESKTOP_FULL_HD_CONTENT_WIDTH, media } from '@constants/layout.ts';
import { Layout } from 'antd';
import styled, { css } from 'styled-components';

export const MainLayoutWrapper = styled(Layout)`
    margin: 16px;
    flex: 1;
    display: flex;
    overflow: hidden;
    min-height: 0;

    overscroll-behavior: contain;

    /* WebKit */
    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
        background: ${SURFACE_COLORS.disabled};
        border-radius: 48px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${SURFACE_COLORS.disabled};
        border-radius: 48px;
    }

    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: ${SURFACE_COLORS.disabled} transparent;
`;

export const LayoutWrapper = styled(Layout)<{ $fullWidth?: boolean }>`
    height: 100vh;
    display: flex;
    flex-direction: column;

    ${({ $fullWidth }) =>
        !$fullWidth &&
        css`
            @media ${media.aboveDesktopFullHD} {
                width: ${ABOVE_DESKTOP_FULL_HD_CONTENT_WIDTH}px;
                margin: 0 auto;
            }
        `}
`;

export const MainContentLayoutWrapper = styled(Layout)`
    position: relative;
    left: -5px;
    flex: 1;
    overflow: auto;
`;

export const ContentLayoutWrapper = styled(BaseContentLayout)`
    margin: 0;
    border-radius: 8px;

    display: flex;
    flex-direction: column;
    overflow-y: auto;
    background: #ecf4fd;
`;
